/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import React from 'react';
import validateImage from '../utils/validateImage';
import breakpoints from '../../config/breakpoints';

const { xs, sm, md } = breakpoints;

// Since the titles of items (without images) need to be aligned, the item cell cannot be centered
// This component is used instead to move items (without images) down when there is an item with an image in the same row
class ImagePlaceholder extends React.Component {
  constructor(props) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
    this.state = {
      imageInRow: false
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    const windowWidth = window && window.innerWidth;
    const itemsPerRow =
      windowWidth < sm.windowWidth
        ? xs.itemsPerRow
        : windowWidth < md.windowWidth
          ? sm.itemsPerRow
          : md.itemsPerRow;
    const imageInRow = this.imageInRow(itemsPerRow);
    if (imageInRow !== this.state.imageInRow) {
      this.setState({ imageInRow });
    }
  }

  imageInRow(itemsPerRow) {
    const { itemIndex, items } = this.props;
    // The row index of the row that contains the item:
    const rowWithItem = Math.ceil((itemIndex + 1) / itemsPerRow);
    // The index of the first item in the row:
    const rowStartIndex = (rowWithItem - 1) * itemsPerRow;
    // The index of the last item in the row:
    const rowEndIndex = rowWithItem * itemsPerRow - 1;

    for (let i = rowStartIndex; i <= rowEndIndex && i < items.length; i++) {
      if (validateImage(items[i])) {
        return true;
      }
    }

    return false;
  }

  render() {
    const { imageInRow } = this.state;

    const style = {
      marginTop: '35%',
      display: imageInRow ? 'block' : 'none'
    };

    return <div style={ style } />;
  }
}

ImagePlaceholder.propTypes = {
  itemIndex: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired
};

export default ImagePlaceholder;
